import * as Types from '@seeqdev/api/graphql/types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useGraphQLFetcher } from '@seeqdev/api';
export type GqlVantageWorksheetCreatorsQueryVariables = Types.Exact<{
  workbookId: Types.Scalars['ID']['input'];
}>;


export type GqlVantageWorksheetCreatorsQuery = { __typename?: 'Query', workbook: { __typename?: 'WorkbookGraphQL', worksheets: Array<{ __typename?: 'WorksheetGraphQL', id: string, creatorId: string | undefined, creatorName: string | undefined }> } };



export const VantageWorksheetCreatorsDocument = `
    query VantageWorksheetCreators($workbookId: ID!) {
  workbook(id: $workbookId) {
    worksheets {
      id
      creatorId: property(name: "creatorId")
      creatorName: property(name: "creatorName")
    }
  }
}
    `;

export const useVantageWorksheetCreatorsQuery = <
      TData = GqlVantageWorksheetCreatorsQuery,
      TError = unknown
    >(
      variables: GqlVantageWorksheetCreatorsQueryVariables,
      options?: Omit<UseQueryOptions<GqlVantageWorksheetCreatorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GqlVantageWorksheetCreatorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GqlVantageWorksheetCreatorsQuery, TError, TData>(
      {
    queryKey: ['VantageWorksheetCreators', variables],
    queryFn: useGraphQLFetcher<GqlVantageWorksheetCreatorsQuery, GqlVantageWorksheetCreatorsQueryVariables>(VantageWorksheetCreatorsDocument).bind(null, variables),
    ...options
  }
    )};

useVantageWorksheetCreatorsQuery.getKey = (variables: GqlVantageWorksheetCreatorsQueryVariables) => ['VantageWorksheetCreators', variables];
